import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "contact-me",
  class: "page"
}
const _hoisted_2 = {
  id: "contact-me-content",
  class: "page-content"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Contact Me", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" I'm always open for any work opportunities or collaborations. If you want to get in touch or just want to share some spicy memes, send me a message by using the form below or by emailing me directly at "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto: ohjiho.ca@gmail.com" }, "ohjiho.ca@gmail.com"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_5 = {
  id: "contact-form",
  ref: "form"
}
const _hoisted_6 = { id: "sender-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            name: "name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
            type: "text",
            placeholder: "Your Name (required)"
          }, null, 512), [
            [_vModelText, _ctx.name]
          ]),
          _withDirectives(_createElementVNode("input", {
            name: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
            type: "email",
            placeholder: "Your Email (required)"
          }, null, 512), [
            [_vModelText, _ctx.email]
          ])
        ]),
        _withDirectives(_createElementVNode("input", {
          name: "subject",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.subject) = $event)),
          type: "text",
          placeholder: "Subject"
        }, null, 512), [
          [_vModelText, _ctx.subject]
        ]),
        _withDirectives(_createElementVNode("textarea", {
          name: "message",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.message) = $event)),
          rows: "5",
          placeholder: "Your Message (required)"
        }, null, 512), [
          [_vModelText, _ctx.message]
        ])
      ], 512),
      _createVNode(_component_Button, {
        text: 'SEND',
        buttonClass: 'small',
        onClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendEmail()))
      }),
      _createVNode(_component_Button, {
        text: 'RESET',
        buttonClass: 'small no-border',
        onClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetForm()))
      })
    ]),
    _createVNode(_component_Footer)
  ]))
}